import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { NumericChange } from 'src/app/models/product-models/views/Attribute';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
  public dialogType = DialogType;

  private _routerSubscription: Subscription | undefined;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}

  ngOnInit() {
    this.renderer.addClass(this.el.nativeElement, 'radius');
    this._routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        filter(() => !!this.dialogRef),
      )
      .subscribe(() => {
        this.dialogRef.close();
      });

    this.dialogRef.backdropClick().subscribe(() => {
      if (this.data.type === DialogType.NORMAL) {
        this.dialogRef.close(false);
      } else {
        this.dialogRef.close({ success: false, data: this.data });
      }
    });
  }

  ngOnDestroy(): void {
    if (this._routerSubscription) this._routerSubscription.unsubscribe();
  }

  stringToNumber(value: string): number {
    return +value;
  }
}

export enum DialogType {
  NORMAL = 'normal',
  PASSWORD = 'password',
  INPUT = 'input',
}

export interface DialogData {
  type: DialogType;
  icon: string;
  title: string;
  color: string;
  text: string;
  actionText: string;
  cancelText: string;
  showCancel: boolean;
  showAction: boolean;
  showClose: boolean;
  inputs: DialogInputData[];
  link: string;
}

export interface DialogInputData {
  type: string;
  name: string;
  placeholder: string;
  value: string;
  numericChange: NumericChange;
}
